import { render, staticRenderFns } from "./PrmSync.vue?vue&type=template&id=2a59f089"
import script from "./PrmSync.vue?vue&type=script&lang=js"
export * from "./PrmSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports